class ContractsDelegate {
    setIsOpen(isOpen) {
        this.setState({
            isOpen,
            editMode: false,
            editingContract: null
        });
    }
}

export default ContractsDelegate;
